import { defineMessages } from 'react-intl';

export default defineMessages({
  stopImpersonation: 'Stop impersonation',
  impersonating: 'Impersonating ',
});
